export const NON_DURATION_CONFIRMATION_TYPES_DISPLAY_MAPPING = {
  MANUAL_RELEASE: "On-Vehicle Release",
  // CLOUD_RELEASE_CONFIRMATION: "On Cloud Relase",
  CLOUD_HMI_RELEASE_CONFIRMATION: "Double Confirm",
};

export const CONFIRMATION_TYPES = {
  DURATION_RELEASE: "DURATION_RELEASE",
  MANUAL_RELEASE: "MANUAL_RELEASE",
  // CLOUD_RELEASE_CONFIRMATION: "CLOUD_RELEASE_CONFIRMATION",
  CLOUD_HMI_RELEASE_CONFIRMATION: "CLOUD_HMI_RELEASE_CONFIRMATION",
};

export type ConfirmationType = keyof typeof CONFIRMATION_TYPES;
